const isParticipant = (meta) => meta.dispatch(isParticipantGuardAction(meta));

const isParticipantGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.userType === 'participant') {
		return null
	}

	return '/'
}

export { isParticipant };
